/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY
// See angular/tools/gulp-tasks/cldr/extract.js

export default [
  [
    ['അ', 'ഉച്ച', 'പുലർച്ചെ', 'രാവിലെ', 'ഉച്ചയ്', 'ഉച്ചതി', 'വൈ', 'സന്ധ്യ', 'രാത്രി'],
    ['അർദ്ധരാത്രി', 'ഉച്ച', 'പുലർച്ചെ', 'രാവിലെ', 'ഉച്ചയ്ക്ക്', 'ഉച്ചതിരിഞ്ഞ്', 'വൈകുന്നേരം', 'സന്ധ്യ', 'രാത്രി'],
  ],
  [
    ['അർദ്ധരാത്രി', 'ഉച്ച', 'പുലർച്ചെ', 'രാവിലെ', 'ഉച്ചയ്ക്ക്', 'ഉച്ചതിരിഞ്ഞ്', 'വൈകുന്നേരം', 'സന്ധ്യ', 'രാത്രി'],
    ,
  ],
  [
    '00:00', '12:00', ['03:00', '06:00'], ['06:00', '12:00'], ['12:00', '14:00'],
    ['14:00', '15:00'], ['15:00', '18:00'], ['18:00', '19:00'], ['19:00', '03:00']
  ]
];
